import { forwardRef, memo, useEffect, useImperativeHandle, useRef } from 'react';

export default memo(
  forwardRef(function Cropper({ autoCropArea, className, onCropStart, src }, ref) {
    const cropper = useRef();
    const cropperImg = useRef();
    const cropperSelection = useRef();

    useEffect(() => {
      import(/* webpackChunkName: "cropper" */ 'cropperjs');
      const cropperEl = cropper.current;
      cropperEl.addEventListener('actionstart', onCropStart);
      return () => cropperEl.removeEventListener('actionstart', onCropStart);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useImperativeHandle(ref, () => ({
      getCroppedCanvas() {
        const scaler = Math.max(
          cropperImg.current.offsetWidth / cropper.current.offsetWidth,
          cropperImg.current.offsetHeight / cropper.current.offsetHeight,
        );
        return cropperSelection.current.$toCanvas({
          width: cropperSelection.current.width * scaler,
          height: cropperSelection.current.height * scaler,
        });
      },
    }));

    return (
      <cropper-canvas background class={className} ref={cropper}>
        <cropper-image
          crossOrigin="anonymous"
          ref={cropperImg}
          rotatable
          scalable
          skewable
          src={src}
          translatable
        ></cropper-image>
        <cropper-shade hidden></cropper-shade>
        <cropper-handle action="select" plain></cropper-handle>
        <cropper-selection
          id="cropperSelection"
          initial-coverage={autoCropArea}
          movable
          ref={cropperSelection}
          resizable
        >
          <cropper-grid covered role="grid"></cropper-grid>
          <cropper-crosshair centered></cropper-crosshair>
          <cropper-handle action="move" theme-color="rgba(255, 255, 255, 0.35)"></cropper-handle>
          <cropper-handle action="n-resize"></cropper-handle>
          <cropper-handle action="e-resize"></cropper-handle>
          <cropper-handle action="s-resize"></cropper-handle>
          <cropper-handle action="w-resize"></cropper-handle>
          <cropper-handle action="ne-resize"></cropper-handle>
          <cropper-handle action="nw-resize"></cropper-handle>
          <cropper-handle action="se-resize"></cropper-handle>
          <cropper-handle action="sw-resize"></cropper-handle>
        </cropper-selection>
      </cropper-canvas>
    );
  }),
);
